// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HWmbo7 {
  display: flex;
  flex-direction: row;
  gap: var(--spacing-3);
  flex: 1;
  width: 100%;
  height: 100%;
}

.lYL7nY {
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
}

.oaYnJ2 {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 14px 16px;
  background: var(--surface-neutral-white);
  border: 1px solid var(--stroke-neutral-subtle);
  border-radius: 10px;
}

.Mh_SCq {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  min-height: 36px;
  padding: 0 15px;
  color: var(--text-neutral-stronger);
  background: var(--surface-neutral-pale, #f5f5f5);
  border: 0;
  border-radius: 6px;
  font: inherit;
  font-size: 15px;
  font-weight: 600;
  white-space: nowrap;
  cursor: pointer;
}

.Mh_SCq:disabled {
  cursor: default;
  opacity: 1;
}

.dG9aRx {
  color: var(--text-neutral-white, #fff);
  background: var(--surface-primary-medium, #d64000);
}

.GqyzeW:not(.dG9aRx) {
  color: #1f6d4c;
  background: #e5f4ed;
}

.mf1RcU {
  display: inline-flex;
  width: 16px;
  height: 16px;
  align-items: center;
  justify-content: center;
}

.Mh_SCq:not(.dG9aRx):not(.GqyzeW) .mf1RcU img {
  filter: grayscale(1) brightness(0.75);
  opacity: 0.9;
}

.dG9aRx .mf1RcU img {
  filter: brightness(0) invert(1);
}

.rvDGkk {
  min-width: var(--spacing-3);
  height: 1px;
  flex: 1;
  margin: 0 var(--spacing-1);
  background: var(--stroke-neutral-subtle);
}

.lYL7nY .OwijPx,
.lYL7nY .IBh_5g {
  height: auto;
  border: 1px solid var(--stroke-neutral-subtle);
  box-shadow: none;
}

.lYL7nY .OwijPx {
  min-width: 0;
  width: auto;
}

.lYL7nY .IBh_5g {
  align-self: flex-start;
  position: sticky;
  top: 16px;
  width: clamp(286px, 23vw, 320px);
  flex: 0 0 clamp(286px, 23vw, 320px);
  gap: 0;
  background: transparent;
  border: 0;
}

.lYL7nY .Moj3gC {
  display: none;
}

.lYL7nY .i88CfR {
  font-weight: var(--font-weight-semibold);
}

.lYL7nY .vwbMp3 {
  padding-top: 24px;
}

.lYL7nY .OwijPx.c_Lt26 {
  background: transparent;
  border: 0;
  box-shadow: none;
}

.lYL7nY .c_Lt26 .vwbMp3 {
  padding: 0;
}

.wH6AXP {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.lYL7nY .L8U8L9 {
  padding: 20px 24px 16px;
  color: var(--text-neutral-stronger);
  background: var(--surface-neutral-white);
  border: 1px solid var(--stroke-neutral-subtle);
  border-bottom: 0;
  border-radius: 9px 9px 0 0;
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
  text-transform: uppercase;
}

.lYL7nY .IBh_5g > .ELKSm5 {
  background: var(--surface-neutral-white);
  border-right: 1px solid var(--stroke-neutral-subtle);
  border-left: 1px solid var(--stroke-neutral-subtle);
}

.lYL7nY .xioJgM {
  padding: 0;
}

.EcP9Hr {
  display: flex;
  flex-direction: column;
  margin: 0;
  padding: 12px 12px 16px;
  background: var(--surface-neutral-white);
  border: 1px solid var(--stroke-neutral-subtle, #e3e3e3);
  border-top: 0;
  border-radius: 0 0 9px 9px;
}

.EcP9Hr button {
  min-height: 36px;
  padding: 0 12px;
  color: var(--text-neutral-stronger, #666);
  text-align: left;
  background: transparent;
  border: 0;
  border-left: 3px solid transparent;
  border-radius: 4px;
  font: inherit;
  cursor: pointer;
}

.EcP9Hr button:disabled {
  cursor: default;
}

.EcP9Hr .Mtc1Au {
  color: var(--text-neutral-dark, #222);
  background: #f0f1f2;
  border-left-color: #3a3d40;
  font-weight: 600;
}

.nDCbny {
  margin-top: 20px;
  padding: 20px 24px 4px;
  color: var(--text-neutral-stronger, #666);
  background: var(--surface-neutral-white);
  border: 1px solid var(--stroke-neutral-subtle, #e3e3e3);
  border-bottom: 0;
  border-radius: 9px 9px 0 0;
  font-size: 13px;
  font-weight: 700;
  text-transform: uppercase;
}

.lYL7nY .ThwNbL {
  margin-top: 0;
  padding: 10px 24px 20px;
  background: var(--surface-neutral-white);
  border: 1px solid var(--stroke-neutral-subtle, #e3e3e3);
  border-top: 0;
  border-radius: 0 0 9px 9px;
}

.lYL7nY .ThwNbL .tHEuw2:nth-child(2),
.lYL7nY .ThwNbL .tHEuw2:nth-child(4) {
  margin-bottom: 8px;
  padding-bottom: 12px;
  border-bottom: 1px solid var(--stroke-neutral-subtle, #e3e3e3);
}

.lYL7nY .ThwNbL .tHEuw2:nth-child(5) {
  margin-top: 2px;
  font-size: 18px;
}

.lYL7nY .ThwNbL .tHEuw2:nth-child(5) ._yOJvY {
  color: var(--text-primary-medium, #d64000);
  font-size: 23px;
  font-weight: 700;
}

.lYL7nY .ThwNbL .tHEuw2:nth-child(6) {
  justify-content: flex-start;
  margin-top: 8px;
}

.lYL7nY .ThwNbL .tHEuw2:nth-child(6) .vViOqL {
  display: none;
}

.lYL7nY .ThwNbL .tHEuw2:nth-child(6) ._yOJvY {
  width: 100%;
  margin: 0;
  color: var(--text-neutral-stronger, #666);
  font-size: 13px;
  font-weight: 400;
}

@media (max-width: 900px) {
  .oaYnJ2 {
    overflow-x: auto;
  }

  .rvDGkk {
    min-width: var(--spacing-2);
    flex: 0 0 var(--spacing-2);
  }

  .lYL7nY .HWmbo7 {
    flex-direction: column;
  }

  .lYL7nY .IBh_5g {
    width: 100%;
    flex-basis: auto;
  }
}

.OwijPx {
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
  height: 100%;
  border-radius: var(--spacing-1);
  background-color: var(--surface-neutral-white);
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.12);
}

.MQoqf3 {
  display: flex;
  gap: var(--spacing-1);
  padding: var(--spacing-2-5) var(--spacing-3);
  align-items: center;
}

.Moj3gC {
  background-color: var(--color-primary, #d64000);
  width: var(--spacing-3);
  height: var(--spacing-3);
  border-radius: 12px;
  text-align: center;
  vertical-align: middle;
}

.HhavcQ {
  font-weight: 600;
  font-size: var(--font-size-md);
  color: var(--background-white, #ffffff);
}

.i88CfR {
  font-size: var(--font-size-lg);
  line-height: 100%;
  letter-spacing: 0px;
  vertical-align: middle;
  font-weight: 400;
  color: var(--surface-neutral-dark);
}

.vwbMp3 {
  min-height: auto;
  max-height: none;
  overflow: visible;
  padding: 0 var(--spacing-3) 24px;
}

.ELKSm5,
.nJf36l {
  border-bottom: 1px solid var(--Color-Gray-200, #e6e6e6);
}

.nJf36l {
  display: block;
  margin: 0;
  height: 1px;
  background-color: var(--Color-Gray-200, #e6e6e6);
}

.IBh_5g {
  width: 355px;
  display: flex;
  flex-direction: column;
  gap: var(--spacing-2-5);
  border-radius: 8px;
  background-color: var(--surface-neutral-white);
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.12);
}

.L8U8L9 {
  display: flex;
  padding: var(--spacing-2-5) var(--spacing-3) 0px var(--spacing-3);
  font-size: 16px;
  color: var(--surface-neutral-dark);
}

.xioJgM {
  display: flex;
  flex-direction: column;
  padding: 0px var(--spacing-3);
  margin-top: 0;
}

.XZdtxN {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.TjRHdG {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: var(--spacing-2) 0;
}

.SVVE5Z {
  display: flex;
  flex-direction: row;
  gap: var(--spacing-1);
  align-items: center;
  color: var(--surface-neutral-dark);
}

.kgwGbH {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  width: 24px;
  height: 24px;
  font-family: 'Source Sans 3', var(--font-family-base);
  font-weight: 600;
  font-size: 14px;
  line-height: 160%;
  text-align: center;
  color: #666666;
  background: transparent;
  border: 1px solid #666666;
}

.kgwGbH.fy6zYP {
  color: var(--background-white, #ffffff);
  background-color: var(--color-primary, #d64000);
  border: 1px solid var(--color-primary);
}

.jImqoj {
  text-indent: 10px;
  color: #666666;
  font-family: 'Source Sans 3', var(--font-family-base);
  font-size: 16px;
  font-weight: 400;
  line-height: 100%;
}

.jImqoj.pxEIj3 {
  color: var(--surface-neutral-dark);
  font-weight: 400;
}

.xA0vUO {
  border: none;
  background: transparent;
  font-size: var(--font-size-lg);
  cursor: pointer;
}

.AfBHZ2 {
  border: none;
  background: transparent;
  font-size: var(--font-size-sm);
  font-weight: 600;
  color: #d32f2f;
  cursor: pointer;
  padding: 2px 8px;
  border-radius: 4px;
  transition: background 0.2s;
}

.AfBHZ2:hover {
  background: rgba(211, 47, 47, 0.08);
}

.ThwNbL {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-1);
  margin-top: var(--spacing-3);
}

.tHEuw2 {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.vViOqL {
  width: 40%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: var(--font-size-md);
  color: var(--surface-neutral-dark);
}

._yOJvY {
  width: 58%;
  margin-left: 2%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: var(--font-size-md);
  font-weight: 600;
  color: var(--surface-neutral-dark);
}
`, "",{"version":3,"sources":["webpack://./../../packages/shared-ui/src/components/FormWizard/FormWizard.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,OAAO;EACP,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,wCAAwC;EACxC,8CAA8C;EAC9C,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,mCAAmC;EACnC,gDAAgD;EAChD,SAAS;EACT,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,sCAAsC;EACtC,kDAAkD;AACpD;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;EACrC,YAAY;AACd;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;EAC3B,WAAW;EACX,OAAO;EACP,0BAA0B;EAC1B,wCAAwC;AAC1C;;AAEA;;EAEE,YAAY;EACZ,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,SAAS;EACT,gCAAgC;EAChC,mCAAmC;EACnC,MAAM;EACN,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,mCAAmC;EACnC,wCAAwC;EACxC,8CAA8C;EAC9C,gBAAgB;EAChB,0BAA0B;EAC1B,8BAA8B;EAC9B,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;EACxC,oDAAoD;EACpD,mDAAmD;AACrD;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,uBAAuB;EACvB,wCAAwC;EACxC,uDAAuD;EACvD,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,yCAAyC;EACzC,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;EACT,kCAAkC;EAClC,kBAAkB;EAClB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;EACnB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,yCAAyC;EACzC,wCAAwC;EACxC,uDAAuD;EACvD,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,wCAAwC;EACxC,uDAAuD;EACvD,aAAa;EACb,0BAA0B;AAC5B;;AAEA;;EAEE,kBAAkB;EAClB,oBAAoB;EACpB,8DAA8D;AAChE;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,SAAS;EACT,yCAAyC;EACzC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,2BAA2B;IAC3B,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,8CAA8C;EAC9C,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;EACE,+CAA+C;EAC/C,uBAAuB;EACvB,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;EAC9B,uCAAuC;AACzC;;AAEA;EACE,8BAA8B;EAC9B,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;;EAEE,uDAAuD;AACzD;;AAEA;EACE,cAAc;EACd,SAAS;EACT,WAAW;EACX,gDAAgD;AAClD;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;EAClB,8CAA8C;EAC9C,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,iEAAiE;EACjE,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;AACR;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,qDAAqD;EACrD,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,uCAAuC;EACvC,+CAA+C;EAC/C,sCAAsC;AACxC;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,qDAAqD;EACrD,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,8BAA8B;EAC9B,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;EACE,UAAU;EACV,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,8BAA8B;EAC9B,gBAAgB;EAChB,kCAAkC;AACpC","sourcesContent":[".contentBody {\n  display: flex;\n  flex-direction: row;\n  gap: var(--spacing-3);\n  flex: 1;\n  width: 100%;\n  height: 100%;\n}\n\n.horizontalWizard {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  width: 100%;\n}\n\n.horizontalSteps {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: 14px 16px;\n  background: var(--surface-neutral-white);\n  border: 1px solid var(--stroke-neutral-subtle);\n  border-radius: 10px;\n}\n\n.horizontalStep {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 7px;\n  min-height: 36px;\n  padding: 0 15px;\n  color: var(--text-neutral-stronger);\n  background: var(--surface-neutral-pale, #f5f5f5);\n  border: 0;\n  border-radius: 6px;\n  font: inherit;\n  font-size: 15px;\n  font-weight: 600;\n  white-space: nowrap;\n  cursor: pointer;\n}\n\n.horizontalStep:disabled {\n  cursor: default;\n  opacity: 1;\n}\n\n.horizontalStepActive {\n  color: var(--text-neutral-white, #fff);\n  background: var(--surface-primary-medium, #d64000);\n}\n\n.horizontalStepDone:not(.horizontalStepActive) {\n  color: #1f6d4c;\n  background: #e5f4ed;\n}\n\n.horizontalStepIcon {\n  display: inline-flex;\n  width: 16px;\n  height: 16px;\n  align-items: center;\n  justify-content: center;\n}\n\n.horizontalStep:not(.horizontalStepActive):not(.horizontalStepDone) .horizontalStepIcon img {\n  filter: grayscale(1) brightness(0.75);\n  opacity: 0.9;\n}\n\n.horizontalStepActive .horizontalStepIcon img {\n  filter: brightness(0) invert(1);\n}\n\n.horizontalStepConnector {\n  min-width: var(--spacing-3);\n  height: 1px;\n  flex: 1;\n  margin: 0 var(--spacing-1);\n  background: var(--stroke-neutral-subtle);\n}\n\n.horizontalWizard .form,\n.horizontalWizard .summary {\n  height: auto;\n  border: 1px solid var(--stroke-neutral-subtle);\n  box-shadow: none;\n}\n\n.horizontalWizard .form {\n  min-width: 0;\n  width: auto;\n}\n\n.horizontalWizard .summary {\n  align-self: flex-start;\n  position: sticky;\n  top: 16px;\n  width: clamp(286px, 23vw, 320px);\n  flex: 0 0 clamp(286px, 23vw, 320px);\n  gap: 0;\n  background: transparent;\n  border: 0;\n}\n\n.horizontalWizard .formTitleStep {\n  display: none;\n}\n\n.horizontalWizard .formTitleLabel {\n  font-weight: var(--font-weight-semibold);\n}\n\n.horizontalWizard .formContent {\n  padding-top: 24px;\n}\n\n.horizontalWizard .form.formPlain {\n  background: transparent;\n  border: 0;\n  box-shadow: none;\n}\n\n.horizontalWizard .formPlain .formContent {\n  padding: 0;\n}\n\n.visuallyHidden {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n.horizontalWizard .summaryTitle {\n  padding: 20px 24px 16px;\n  color: var(--text-neutral-stronger);\n  background: var(--surface-neutral-white);\n  border: 1px solid var(--stroke-neutral-subtle);\n  border-bottom: 0;\n  border-radius: 9px 9px 0 0;\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-semibold);\n  text-transform: uppercase;\n}\n\n.horizontalWizard .summary > .divider {\n  background: var(--surface-neutral-white);\n  border-right: 1px solid var(--stroke-neutral-subtle);\n  border-left: 1px solid var(--stroke-neutral-subtle);\n}\n\n.horizontalWizard .summaryItems {\n  padding: 0;\n}\n\n.horizontalSummaryNavigation {\n  display: flex;\n  flex-direction: column;\n  margin: 0;\n  padding: 12px 12px 16px;\n  background: var(--surface-neutral-white);\n  border: 1px solid var(--stroke-neutral-subtle, #e3e3e3);\n  border-top: 0;\n  border-radius: 0 0 9px 9px;\n}\n\n.horizontalSummaryNavigation button {\n  min-height: 36px;\n  padding: 0 12px;\n  color: var(--text-neutral-stronger, #666);\n  text-align: left;\n  background: transparent;\n  border: 0;\n  border-left: 3px solid transparent;\n  border-radius: 4px;\n  font: inherit;\n  cursor: pointer;\n}\n\n.horizontalSummaryNavigation button:disabled {\n  cursor: default;\n}\n\n.horizontalSummaryNavigation .horizontalSummaryNavigationActive {\n  color: var(--text-neutral-dark, #222);\n  background: #f0f1f2;\n  border-left-color: #3a3d40;\n  font-weight: 600;\n}\n\n.horizontalSummaryValueTitle {\n  margin-top: 20px;\n  padding: 20px 24px 4px;\n  color: var(--text-neutral-stronger, #666);\n  background: var(--surface-neutral-white);\n  border: 1px solid var(--stroke-neutral-subtle, #e3e3e3);\n  border-bottom: 0;\n  border-radius: 9px 9px 0 0;\n  font-size: 13px;\n  font-weight: 700;\n  text-transform: uppercase;\n}\n\n.horizontalWizard .summarySection {\n  margin-top: 0;\n  padding: 10px 24px 20px;\n  background: var(--surface-neutral-white);\n  border: 1px solid var(--stroke-neutral-subtle, #e3e3e3);\n  border-top: 0;\n  border-radius: 0 0 9px 9px;\n}\n\n.horizontalWizard .summarySection .summaryRow:nth-child(2),\n.horizontalWizard .summarySection .summaryRow:nth-child(4) {\n  margin-bottom: 8px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid var(--stroke-neutral-subtle, #e3e3e3);\n}\n\n.horizontalWizard .summarySection .summaryRow:nth-child(5) {\n  margin-top: 2px;\n  font-size: 18px;\n}\n\n.horizontalWizard .summarySection .summaryRow:nth-child(5) .summarySectionValue {\n  color: var(--text-primary-medium, #d64000);\n  font-size: 23px;\n  font-weight: 700;\n}\n\n.horizontalWizard .summarySection .summaryRow:nth-child(6) {\n  justify-content: flex-start;\n  margin-top: 8px;\n}\n\n.horizontalWizard .summarySection .summaryRow:nth-child(6) .summarySectionTitle {\n  display: none;\n}\n\n.horizontalWizard .summarySection .summaryRow:nth-child(6) .summarySectionValue {\n  width: 100%;\n  margin: 0;\n  color: var(--text-neutral-stronger, #666);\n  font-size: 13px;\n  font-weight: 400;\n}\n\n@media (max-width: 900px) {\n  .horizontalSteps {\n    overflow-x: auto;\n  }\n\n  .horizontalStepConnector {\n    min-width: var(--spacing-2);\n    flex: 0 0 var(--spacing-2);\n  }\n\n  .horizontalWizard .contentBody {\n    flex-direction: column;\n  }\n\n  .horizontalWizard .summary {\n    width: 100%;\n    flex-basis: auto;\n  }\n}\n\n.form {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  width: 100%;\n  height: 100%;\n  border-radius: var(--spacing-1);\n  background-color: var(--surface-neutral-white);\n  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.12);\n}\n\n.formTitle {\n  display: flex;\n  gap: var(--spacing-1);\n  padding: var(--spacing-2-5) var(--spacing-3);\n  align-items: center;\n}\n\n.formTitleStep {\n  background-color: var(--color-primary, #d64000);\n  width: var(--spacing-3);\n  height: var(--spacing-3);\n  border-radius: 12px;\n  text-align: center;\n  vertical-align: middle;\n}\n\n.formTitleStepLabel {\n  font-weight: 600;\n  font-size: var(--font-size-md);\n  color: var(--background-white, #ffffff);\n}\n\n.formTitleLabel {\n  font-size: var(--font-size-lg);\n  line-height: 100%;\n  letter-spacing: 0px;\n  vertical-align: middle;\n  font-weight: 400;\n  color: var(--surface-neutral-dark);\n}\n\n.formContent {\n  min-height: auto;\n  max-height: none;\n  overflow: visible;\n  padding: 0 var(--spacing-3) 24px;\n}\n\n.divider,\n.dividerItem {\n  border-bottom: 1px solid var(--Color-Gray-200, #e6e6e6);\n}\n\n.dividerItem {\n  display: block;\n  margin: 0;\n  height: 1px;\n  background-color: var(--Color-Gray-200, #e6e6e6);\n}\n\n.summary {\n  width: 355px;\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-2-5);\n  border-radius: 8px;\n  background-color: var(--surface-neutral-white);\n  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.12);\n}\n\n.summaryTitle {\n  display: flex;\n  padding: var(--spacing-2-5) var(--spacing-3) 0px var(--spacing-3);\n  font-size: 16px;\n  color: var(--surface-neutral-dark);\n}\n\n.summaryItems {\n  display: flex;\n  flex-direction: column;\n  padding: 0px var(--spacing-3);\n  margin-top: 0;\n}\n\n.summaryItem {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n}\n\n.summaryItemHeader {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  padding: var(--spacing-2) 0;\n}\n\n.summaryItemTitle {\n  display: flex;\n  flex-direction: row;\n  gap: var(--spacing-1);\n  align-items: center;\n  color: var(--surface-neutral-dark);\n}\n\n.summaryItemNumber {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 12px;\n  width: 24px;\n  height: 24px;\n  font-family: 'Source Sans 3', var(--font-family-base);\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 160%;\n  text-align: center;\n  color: #666666;\n  background: transparent;\n  border: 1px solid #666666;\n}\n\n.summaryItemNumber.summaryItemNumberActive {\n  color: var(--background-white, #ffffff);\n  background-color: var(--color-primary, #d64000);\n  border: 1px solid var(--color-primary);\n}\n\n.summaryItemLabel {\n  text-indent: 10px;\n  color: #666666;\n  font-family: 'Source Sans 3', var(--font-family-base);\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 100%;\n}\n\n.summaryItemLabel.summaryItemLabelIsReached {\n  color: var(--surface-neutral-dark);\n  font-weight: 400;\n}\n\n.editStep {\n  border: none;\n  background: transparent;\n  font-size: var(--font-size-lg);\n  cursor: pointer;\n}\n\n.errorAction {\n  border: none;\n  background: transparent;\n  font-size: var(--font-size-sm);\n  font-weight: 600;\n  color: #d32f2f;\n  cursor: pointer;\n  padding: 2px 8px;\n  border-radius: 4px;\n  transition: background 0.2s;\n}\n\n.errorAction:hover {\n  background: rgba(211, 47, 47, 0.08);\n}\n\n.summarySection {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-1);\n  margin-top: var(--spacing-3);\n}\n\n.summaryRow {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.summarySectionTitle {\n  width: 40%;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  font-size: var(--font-size-md);\n  color: var(--surface-neutral-dark);\n}\n\n.summarySectionValue {\n  width: 58%;\n  margin-left: 2%;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  font-size: var(--font-size-md);\n  font-weight: 600;\n  color: var(--surface-neutral-dark);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"contentBody": `HWmbo7`,
	"horizontalWizard": `lYL7nY`,
	"horizontalSteps": `oaYnJ2`,
	"horizontalStep": `Mh_SCq`,
	"horizontalStepActive": `dG9aRx`,
	"horizontalStepDone": `GqyzeW`,
	"horizontalStepIcon": `mf1RcU`,
	"horizontalStepConnector": `rvDGkk`,
	"form": `OwijPx`,
	"summary": `IBh_5g`,
	"formTitleStep": `Moj3gC`,
	"formTitleLabel": `i88CfR`,
	"formContent": `vwbMp3`,
	"formPlain": `c_Lt26`,
	"visuallyHidden": `wH6AXP`,
	"summaryTitle": `L8U8L9`,
	"divider": `ELKSm5`,
	"summaryItems": `xioJgM`,
	"horizontalSummaryNavigation": `EcP9Hr`,
	"horizontalSummaryNavigationActive": `Mtc1Au`,
	"horizontalSummaryValueTitle": `nDCbny`,
	"summarySection": `ThwNbL`,
	"summaryRow": `tHEuw2`,
	"summarySectionValue": `_yOJvY`,
	"summarySectionTitle": `vViOqL`,
	"formTitle": `MQoqf3`,
	"formTitleStepLabel": `HhavcQ`,
	"dividerItem": `nJf36l`,
	"summaryItem": `XZdtxN`,
	"summaryItemHeader": `TjRHdG`,
	"summaryItemTitle": `SVVE5Z`,
	"summaryItemNumber": `kgwGbH`,
	"summaryItemNumberActive": `fy6zYP`,
	"summaryItemLabel": `jImqoj`,
	"summaryItemLabelIsReached": `pxEIj3`,
	"editStep": `xA0vUO`,
	"errorAction": `AfBHZ2`
};
module.exports = ___CSS_LOADER_EXPORT___;
